import instance from '../config/axios';
import { Endpoints } from './endPoints';

export const getGuestProductConditions = async () => {
  try {
    const result = await instance({
      url: Endpoints.GET_GUEST_PRODUCT_CONDITIONS,
      method: 'GET',
    });

    return result?.data;
  } catch (error) {
    console.error('Error fetching guest product conditions:', error);
    return null;
  }
};
